import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonFunctionModule } from './common.function.module';
import { IGbizDelegationUserInfo, IGbizDelegationCategoryInfoList } from '@interface/gbiz.interface';
import moment from 'moment-timezone';

@Injectable({
  providedIn: CommonFunctionModule,
})
export class CommonFunction {
  constructor(private snackBar: MatSnackBar, private translate: TranslateService) { }

  /**
   * ja.json||en.jsonのパースにより、TranslateServiceから対応する言語内容を取得する
   * @param {string} langPath
   * @returns {string} 対応する言語内容
   */
  getTransValue(langPath: string) {
    const lang = this.translate.store.currentLang;
    let res = this.translate.store.translations[lang];

    langPath.split('.').map((singlePath) => {
      res = res[singlePath];
    });

    return res ? res : langPath;
  }

  /**
   * @description: SnackBarを設定＆表示する
   * @param {string} msg 表示内容
   * @return {void}
   */
  openSnackBarInfo(msg: string): void {
    this.snackBar.open(this.getTransValue(msg), this.getTransValue('BUTTON.CLOSE'), {
      duration: 4000,
    });
  }

  /** 代理申請ステータスから代理ログイン中であるか判定する。 */
  isDelegationApply(delegationStatus: string): boolean {
    return this.notEmpty(delegationStatus);
  }

  /** 空文字でないことを判定する。 */
  notEmpty(text: string): boolean {
    const values = new Set([undefined, 'undefined', null, 'null', '']);

    return !values.has(text);
  }

  /** 空文字であるか判定する */
  isEmptyEx(text: string): boolean {
    return !this.notEmpty(text);
  }

  /**
   * 指定されたテキストが空かどうかをチェックし、空の場合はデフォルトテキストを返します。
   * 空でない場合は元のテキストをそのまま返します。
   * @param text チェック対象のテキスト
   * @param defaultText 空の場合に返すデフォルトテキスト
   * @returns 処理後のテキスト
   */
  getTextOrDefault(text: string, defaultText: string): string {
    return this.isEmptyEx(text) ? defaultText : text;
  }

  /** 委任元がGビズアカウントであるか判別する。 */
  isDelGbizAccount(user: IGbizDelegationUserInfo): boolean {
    const val1 = user.meti_id != undefined && user.meti_id != null;
    const val2 = !this.isEmptyEx(user.user_email);

    return val1 && val2;
  }

  /** 任意の区切り文字を使用し、文字列を配列に分割して返す */
  splitStringToArray(inputString: string, delimiter: string): string[] {
    if (!inputString || !delimiter) {
      return [];
    }
    const resultArray = inputString.split(delimiter);
    return resultArray
      .map(item => item.trim())
      .filter(item => item.length > 0);
  }

  /** 委任期間内か判定する */
  isWithinStartEnd(info: IGbizDelegationCategoryInfoList): boolean {
    if (!info) return false;

    const nowDateFormat = this.getNowDateTimeJST();
    const isFromValid = info.delegation_start
      && (info.delegation_start <= nowDateFormat);
    const isToValid = !info.delegation_end
      || (info.delegation_end && (nowDateFormat <= info.delegation_end));

    return isFromValid && isToValid;
  }

  /** 現在の年月日を取得する */
  getNowDateTimeJST(): string {
    return moment().tz('Asia/Tokyo').format('YYYYMMDD');
  }
}